import BoltIcon from '@mui/icons-material/Bolt'
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment'
import WaterDropIcon from '@mui/icons-material/WaterDrop'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import PropTypes from 'prop-types'
import { describeLastReading } from '@/lib/freshnessCopy'
import { meterCategoryLabel } from '@/lib/meterCategories'
import EntityLink from '../EntityLink'
import { METER_TYPES, meterName } from '../relations'

const FUEL_ICONS = {
    'electricity-meter': <BoltIcon fontSize="small" />,
    'gas-meter': <LocalFireDepartmentIcon fontSize="small" />,
    'water-meter': <WaterDropIcon fontSize="small" />
}

/** A list of meters, each a peek link, with its fuel and how fresh its data is. */
export default function MeterRows({ entries }) {
    return (
        <List dense disablePadding>
            {entries.map(({ type, meter }) => {
                const freshness =
                    type === 'electricity-meter'
                        ? describeLastReading(meter.lastReadingAt).text
                        : null
                return (
                    <ListItem key={`${type}:${meter.id}`} disableGutters>
                        <ListItemIcon
                            sx={{ minWidth: 32, color: 'text.secondary' }}
                        >
                            {FUEL_ICONS[type]}
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <EntityLink type={type} id={meter.id}>
                                    {meterName(type, meter)}
                                </EntityLink>
                            }
                            secondary={[
                                METER_TYPES[type].label,
                                meter.category
                                    ? meterCategoryLabel(meter.category)
                                    : null,
                                freshness
                            ]
                                .filter(Boolean)
                                .join(' · ')}
                        />
                    </ListItem>
                )
            })}
        </List>
    )
}

MeterRows.propTypes = {
    entries: PropTypes.arrayOf(
        PropTypes.shape({ meter: PropTypes.object, type: PropTypes.string })
    ).isRequired
}
